import styled from 'styled-components';

export const SymptomRowDiv = styled.div<{
  symptom: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  > * [class*='MuiButtonBase'] {
    padding: 0 !important;
  }
`;

export const SymptomLabelDiv = styled.div<{
  color: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  white-space: nowrap;
  color: ${(props) => props.color};
`;

export const FlexColum = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

/* Phone: narrow rem cap + border-box; wider viewports: vw cap (matches MUI "sm" breakpoint) */
const phoneMax = '@media (max-width: 600px)';

export const SIAStatementDiv = styled.div`
  max-width: 20vw;
  padding: 5px;
  ${phoneMax} {
    max-width: min(100%, 22rem);
    box-sizing: border-box;
  }
`;

export const CodeListDiv = styled.div`
  max-width: 25vw;
  padding: 5px;
  ${phoneMax} {
    max-width: min(100%, 28rem);
    box-sizing: border-box;
  }
`;

export const SIATitleDiv = styled.div`
  font-size: 1.25em;
  max-width: 20vw;
  text-decoration: underline;
  ${phoneMax} {
    max-width: min(100%, 22rem);
    box-sizing: border-box;
  }
`;

export const CodeDiv = styled.div`
  padding-right: 5px;
  font-size: 1.5em;
`;

export const CodeTextDiv = styled.div`
  padding-top: 0.5em;
`;

export const HopeVisitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TooltipDiv = styled.div`
  padding: 5px;
`;
